import { useState, useCallback } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { GraphQLInventoryRepository } from 'infrastructure/graphql/InventoryRepositoryImpl'

export function useDeleteInventory() {
  const { getIdTokenClaims } = useAuth0()

  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const deleteInventory = useCallback(
    async (inventoryId: string) => {
      setDeleting(true)
      setError(null)
      try {
        const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
        const repo = new GraphQLInventoryRepository(getToken)
        await repo.delete(inventoryId)
      } catch (err: any) {
        setError(err)
        throw err
      } finally {
        setDeleting(false)
      }
    },
    [getIdTokenClaims]
  )

  return { deleteInventory, deleting, error }
}
